import React, { useState, useEffect } from "react";
import RoleBadge from "./RoleBadge";
import LogoMarquee from "./LogoMarquee";
import ArrowAnimation from "./ArrowAnimation";

function Home() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="bg-white">
      <div 
        className={`flex flex-col items-center justify-center h-screen bg-white transition-opacity duration-1000 ease-in-out ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <h1 className="home-name font-light">Edwin Kassier</h1>
        <RoleBadge delay={300} />
        <div className="pt-32"/>
        <LogoMarquee/>
      </div>
    </section>
  );
}

export default Home;
